meedy.factory('meedy.storedDocumentService', ['$q', '$translate', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig',
    function ($q, $translate, baseService, objectHelper, config) {

        function StoredDocument() {

            var wpAnnexUrl = '/medicalPost/documents/wp/annex';
            
            
            this.getWpAnnex = function() {
                return baseService.get(config.API_URL + wpAnnexUrl, {responseType: 'blob'}).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };
            
            this.setWpAnnex = function() {
                return baseService.post(config.API_URL + wpAnnexUrl, {}).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };
            
            this.wpAnnexAvailable = function() {
                return baseService.get(config.API_URL + wpAnnexUrl + '/available').then(
                    function(successResponse) {
                        return successResponse==='true';
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

        }

        return new StoredDocument();
    }
]);